"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireDefault(require("../../Card"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Icon = function Icon() {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "check",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
  }));
};

var CheckedEl = (0, _styledComponents["default"])(_Card["default"]).withConfig({
  displayName: "CheckedIcon__CheckedEl",
  componentId: "sc-73dfdp-0"
})(["color:white;font-size:12px;padding:4px;"]);

var CheckedIcon = function CheckedIcon(_ref) {
  var color = _ref.color;
  return _react["default"].createElement(CheckedEl, {
    borderRadius: 4,
    bg: "".concat(color, ".500"),
    width: 22,
    height: 22
  }, _react["default"].createElement(Icon, null));
};

CheckedIcon.defaultProps = {
  theme: _theme["default"],
  color: 'teal'
};

var _default = (0, _styledComponents.withTheme)(CheckedIcon);

exports["default"] = _default;